import _ from 'lodash';

import { combinationsValues } from 'src/utils/racingCombinations';

const addCardInfoToBetslip = (tillApi) => {
  const bets = JSON.parse(JSON.stringify(tillApi.betFormat));
  const { betHeader } = tillApi;
  let selectionType:'differentStake' | 'totalStake' | 'sameStake' = betHeader.isStakeTotal ? 'totalStake' : 'differentStake';
  let slip = 0;
  const bankerBets = [];

  for (const bet of bets){
    bet.stake = betHeader.stake;
    bet.datetime = bet.datetime * 1000;

    if (bet.productType === 4){
      bet.type = 'numbers';
      const ballType = bet.regularToPredictionCount || bet.sameBallSet ? 'ball' : 'star';
      const numbers = _.map(bet.selectedNumbers, (number) => {
        return { number: +number, type: ballType, isBanker: false, color: bet.colorsRegular[+number-1] };
      });
      bet.selectedNumbers = numbers;
      bet.marketOutcomeCode = bet.outcomeCode;
      bet.sport = 'lotto';

      const numbersToPredictCount = bet.regularToPredictionCount ? bet.regularToPredictionCount : bet.numbersToPredictCount;
      bet.market = {
        code: bet.marketCode,
        typeCode: bet.regularToPredictionCount ? 500 : 700,
        numbersToPredictCount,
        outcomes: [{ code:bet.marketOutcomeCode, value: bet.odds }],
        specifiers: [{ value: numbersToPredictCount }]
      };
    }

    if (bet.productType === 1){
      bet.marketOutcomeCode = bet.outcomeCode;
    }

    if (bet.productType === 2 && bet.numbersToPredictCount > 1){
      bet.horsePosition = bet.posMatrix;
      bet.eventName = bet.tournamentName;
      bet.odds = 'TP';
      bet.type = 'racing';
      bet.repetitionsCount= !bet.isCrossEventMarket ? 1 : 2; // Pick markets are always combo.
      bet.horseType= 'TP';
      bet.racingType= 'horses'; // missing the icon
      bet.marketDetails = {
        name: bet.marketName,
        isCrossEventMarket: bet.isCrossEventMarket,
        predictionCount: bet.numbersToPredictCount,
        crossEventCodes: bet.isCrossEventMarket ? [...Array(bet.numbersToPredictCount)].map(() => Array(0)) : [] };
      bet.sport = 'racing';

      if (!bet.isCrossEventMarket){
        bet.selectionType = 'singlePerm';
        bet.outcome= 'Single/Perm';

        if (_.filter(bet.posMatrix, (position) => position.length === 0).length === bet.posMatrix.length && bet.boxed.length > 0){
          bet.outcome= 'Boxed';
        }

        if (_.some(bet.posMatrix, (position) => position.length === 0) && bet.floatedBanker.length > 0){
          bet.selectionType = 'floating';
          bet.outcome = 'Floating';
        }
      }

      if (bet.boxed && bet.boxed.length > 0){
        //Add all position if we have a boxed
        bet.horsePosition.push(bet.boxed);
      }
      if (bet.floatedBanker && bet.floatedBanker.length > 0){
        //Add banker position if we have a floating banker
        bet.horsePosition = [bet.floatedBanker, bet.boxed];
      }
      const horseSet = {};
      for (let i=0; i<= bet.horsePosition.length; i+=1){
        const key = i === bet.numbersToPredictCount ? 'all' : i+1;
        horseSet[key] = bet.horsePosition[i] || [];
      }
      bet.orderedPosition = horseSet;

      while (bet.horsePosition.length < bet.numbersToPredictCount){
        bet.horsePosition.push([]);
      }
      bet.marketOutcomeCode = bet.outcomeCode;
      bet.prediction = combinationsValues(horseSet, bet.outcome, bet.marketDetails, bet.horsePosition);
    } else if (bet.productType === 2 && bet.numbersToPredictCount === 1){
      bet.marketOutcomeCode = bet.outcomeCode;
      bet.outcome = bet.outcomeName;
      bet.type = 'racing';
      bet.eventName = bet.tournamentName;
      bet.racingType= 'horses'; // missing the icon
      bet.oddsType = 3;
      bet.predictionCount = 1;
      bet.startNo = bet.competitorId;
      bet.sport = 'racing';
      bet.horseType = 'FO';
      bet.odds = bet.odds === +bet.odds ? bet.odds : null;
      bet.prediction = {
        numbersToPredictCount: bet.numbersToPredictCount,
        anyNumbers: [bet.competitorId],
        rankedNumbers:[],
        inOrder: false
      };
    }

    if (bet.isBanker){
      bankerBets.push(bet);
    }
  }

  if (betHeader.isAcca && bets.length > 1){
    slip = 1;
    selectionType = 'totalStake';
  } else if (!_.isEmpty(betHeader.system)){
    slip = 2;
  }

  return { bets, bankerBets, slip, selectionType, system: betHeader.system, stake: betHeader.stake, isStakeTotal: betHeader.isStakeTotal };
};

export { addCardInfoToBetslip };
